import maCameraComponent from '@/components/cameraComponent'

export default {
  name: 'cameraSimple',

  props: {
    title: {
      required: true,
      type: String
    },
    photosNumber: {
      required: false,
      type: Number,
      default: 1
    }
  },

  components: {
    maCameraComponent
  },

  computed: {
    stepsArray() {
      // crea un array de longitud `stepsCount` y lo rellena con los índices del 0 al `stepsCount - 1`
      return Array.from({ length: this.stepsCount }, (_, index) => index)
    }
  },

  methods: {
    handlePhotos(photos) {
      if (photos.length === this.photosNumber) {
        this.$emit('photosArray', photos)
      }
    },

    takePhoto() {
      setTimeout(() => {
        this.$refs.camera.takePhoto()
      }, 1000)
    },

    switchCamera() {
      this.$refs.camera.switchCamera()
    },

    resetInputValue() {
      if (this.$refs.gallery) {
        this.$refs.gallery.value = null
      }
    },

    async handleChangeInput(event) {
      if (event.target.files.length === 0) return

      const file = event.target.files[0]
      const fileSize = file.size
      const fileExtension = file.type
      const maxValueFilesize = 6000000
      const acceptedFileExtensions = 'image/jpg , image/jpeg , image/png'
      const fileSizeValidation = fileSize >= maxValueFilesize
      const isAcceptedFileExtension =
        acceptedFileExtensions.includes(fileExtension)

      if (fileSizeValidation || !isAcceptedFileExtension) {
        this.resetInputValue()
      } else {
        await this.$refs.camera.addPhotoFromGallery(file)
      }
    }
  }
}
